/* Peppo bundle engine (Life Skills family): batch-adds the launch bundle when the main kit is added.
   Products are never added until the buyer submits the product form. Cart UI lives in pk-cart.js. */
document.addEventListener('DOMContentLoaded', () => {
  const sticky = document.querySelector('[data-dm-sticky-atc]');
  const primaryButton = document.querySelector('.product-form__submit');
  if (!sticky || !primaryButton) return;
  const updateSticky = () => { sticky.classList.toggle('is-visible', primaryButton.getBoundingClientRect().bottom < 0); };
  updateSticky();
  document.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky, { passive: true });
});

(() => {
  const AUTO_BUNDLE_KEY = 'dm-auto-bundle-v13';
  const bundleProducts = [
    { title: 'Parenting Guidance Guide', variantId: 67596074647720 },
    { title: 'Solar System Busy Book', variantId: 67596232884392 },
    { title: 'Confidence and Self Esteem Flashcards', variantId: 67596074516648 },
    { title: 'Anger Management for Kids', variantId: 67596074483880 },
    { title: 'Decision Making for Kids', variantId: 67596074582184 },
    { title: 'Lifetime access and updates', variantId: 67596233146536 },
    // Cross-family extras are on by default too (AOV); every switch still truly removes the charged line.
    { title: 'Puzzle Games for Kids', variantId: 67596075270312 },
    { title: 'Do-a-Dot Activity Book', variantId: 67596075237544 },
    { title: 'Early Learning Booster Pack', variantId: 67596075172008 },
    { title: 'Sight Words Activities', variantId: 67596075139240 },
    // Free gift for every Life Skills order (bonus stacking).
    { title: 'Phonics Activity Bundle', variantId: 67596233408680 },
    // Free app bonus: a $0 line on every order so it shows at checkout and in the confirmation email.
    { title: 'FREE BONUS: Peppo Kids App Premium Access', variantId: 67596498075816 }
  ];
  const MAIN_VARIANT_ID = 67596073795752;
  const PHONICS_MAIN_ID = 67596074418344;
  const readState = () => { try { return sessionStorage.getItem(AUTO_BUNDLE_KEY); } catch (_) { return null; } };
  const writeState = (value) => { try { sessionStorage.setItem(AUTO_BUNDLE_KEY, value); } catch (_) {} };
  let initialCartPromise;
  let cartSnapshotAt = 0;

  const requestJson = async (url, options = {}) => {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 8000);
    try {
      const response = await fetch(url, { ...options, signal: controller.signal });
      const body = await response.text();
      let data;
      try { data = JSON.parse(body); } catch { throw new Error(`Cart returned ${response.status || 'an invalid response'}`); }
      if (!response.ok) throw new Error(data?.description || data?.message || `Cart request failed (${response.status})`);
      return data;
    } finally { window.clearTimeout(timeout); }
  };

  // Warm only the cart snapshot (re-fetched after 5s so another tab's edits are seen).
  const warmCart = () => {
    if (!initialCartPromise || Date.now() - cartSnapshotAt > 5000) {
      cartSnapshotAt = Date.now();
      initialCartPromise = requestJson(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then((cart) => { if (!cart.items?.length) writeState('armed'); return cart; })
        .catch(() => { initialCartPromise = null; return null; });
    }
    return initialCartPromise;
  };

  window.PeppoBundle = {
    snapshot: warmCart,
    invalidate() { initialCartPromise = null; },
    async prepareFormData(formData) {
      if (Number(formData.get('id')) !== MAIN_VARIANT_ID) return false;
      const cart = await warmCart();
      if (!cart) return false;
      let existingIds = new Set(cart.items.map((item) => Number(item.variant_id)));
      // One kit per cart: switching from the Phonics kit starts a fresh Life Skills bundle.
      if (existingIds.has(PHONICS_MAIN_ID)) {
        try { await requestJson(`${window.Shopify?.routes?.root || '/'}cart/clear.js`, { method: 'POST' }); } catch (_) {}
        existingIds = new Set(); writeState('armed'); initialCartPromise = null;
      }
      // An existing bundle is already the buyer's selection, including removals made in another tab.
      if (existingIds.has(MAIN_VARIANT_ID) || readState() === 'edited') return false;
      const missing = bundleProducts.filter((product) => !existingIds.has(product.variantId) &&
        !(product.variantId === 67596232884392 && existingIds.has(67596233113768)));
      if (!missing.length) { writeState('complete'); return false; }
      for (const [key, value] of [...formData.entries()]) {
        if (key === 'id' || key === 'quantity' || key === 'selling_plan' || key.startsWith('properties[')) {
          const itemKey = key.startsWith('properties[') ? `items[0][properties]${key.slice(10)}` : `items[0][${key}]`;
          formData.append(itemKey, value);
          formData.delete(key);
        }
      }
      if (!formData.has('items[0][quantity]')) formData.append('items[0][quantity]', '1');
      missing.forEach((product, index) => {
        const prefix = `items[${index + 1}]`;
        formData.append(`${prefix}[id]`, String(product.variantId));
        formData.append(`${prefix}[quantity]`, '1');
        formData.append(`${prefix}[properties][_ocu_cart_upsell_id]`, `dm-launch-${product.variantId}`);
        formData.append(`${prefix}[properties][_dm_bundle_addon]`, 'true');
      });
      writeState('batch-adding');
      return true;
    },
    complete(success) {
      writeState(success ? 'complete' : 'failed');
      initialCartPromise = null;
      document.documentElement.classList.remove('dm-bundle-preparing');
    }
  };

  document.addEventListener('submit', (event) => {
    if (!event.target.closest('.template-product product-form, .template-product .product-form')) return;
    if (Number(event.target.querySelector('[name="id"]')?.value) !== MAIN_VARIANT_ID) return;
    if (readState() !== 'edited') writeState('armed');
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', warmCart, { once: true });
  else warmCart();
})();
